import React from "react";

export const deleteFailure = (
  <p className="alert alert-danger">
    Could not remove page, please check JavaScript console for more details.
  </p>
);

export const deleteHomePg = (
  <p className="alert alert-warning">
    Warning: You cannot delete the page assigned as "Home". Please assign
    another page as the home page first.
  </p>
);



// WEBPACK FOOTER //
// ./src/admin/components/Page-alerts.js